export const SHOW_ANIMATION_HOME_PAGE_TIMER = 60000;
export const SHOW_ANIMATION_QUICK_MATCH_TIMER = 10000;
export const OPEN_CHAT_TIMER = 15000;
export const SHOW_TOOLTIPS_HOME_PAGE = 25000;
export const OPEN_CONNECT_TIMER = 60000;
